// extracted by mini-css-extract-plugin
export default {"wrapper":"ComponentNavigator_wrapper__nla3h","title":"ComponentNavigator_title__pIe7u"};